import * as Types from '../../../.cache/__types__/index';

import { gql } from '@apollo/client';
import { BillingSubscriptionPriceDetailsFragmentDoc } from '../../fragments/billing-subscription/price.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BillingSubscriptionPricesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type BillingSubscriptionPricesQuery = { __typename?: 'Query', billingSubscriptionPrices?: Array<{ __typename?: 'BillingSubscriptionPrice', id: string, display_name?: string | null, unit_amount: number, currency: string, interval: string, stripe_price_id?: string | null, subscription_type?: Types.BillingSubscriptionType | null, is_current?: boolean | null, product?: { __typename?: 'BillingSubscriptionProduct', type?: Types.WorkspaceType | null, display_name?: string | null, trial_period_days?: number | null, min_card_count?: number | null, max_card_count?: number | null, is_current?: boolean | null, provider: Types.BillingSubscriptionProvider } | null }> | null };


export const BillingSubscriptionPricesDocument = gql`
    query BillingSubscriptionPrices {
  billingSubscriptionPrices {
    ...BillingSubscriptionPriceDetails
  }
}
    ${BillingSubscriptionPriceDetailsFragmentDoc}`;

/**
 * __useBillingSubscriptionPricesQuery__
 *
 * To run a query within a React component, call `useBillingSubscriptionPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingSubscriptionPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingSubscriptionPricesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBillingSubscriptionPricesQuery(baseOptions?: Apollo.QueryHookOptions<BillingSubscriptionPricesQuery, BillingSubscriptionPricesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingSubscriptionPricesQuery, BillingSubscriptionPricesQueryVariables>(BillingSubscriptionPricesDocument, options);
      }
export function useBillingSubscriptionPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingSubscriptionPricesQuery, BillingSubscriptionPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingSubscriptionPricesQuery, BillingSubscriptionPricesQueryVariables>(BillingSubscriptionPricesDocument, options);
        }
export function useBillingSubscriptionPricesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingSubscriptionPricesQuery, BillingSubscriptionPricesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BillingSubscriptionPricesQuery, BillingSubscriptionPricesQueryVariables>(BillingSubscriptionPricesDocument, options);
        }
export type BillingSubscriptionPricesQueryHookResult = ReturnType<typeof useBillingSubscriptionPricesQuery>;
export type BillingSubscriptionPricesLazyQueryHookResult = ReturnType<typeof useBillingSubscriptionPricesLazyQuery>;
export type BillingSubscriptionPricesSuspenseQueryHookResult = ReturnType<typeof useBillingSubscriptionPricesSuspenseQuery>;
export type BillingSubscriptionPricesQueryResult = Apollo.QueryResult<BillingSubscriptionPricesQuery, BillingSubscriptionPricesQueryVariables>;